import { Record } from 'immutable'

export class CargoType extends Record({
    id: undefined,
    name: undefined,
    is_security_required: undefined,
    is_cooling_required: undefined,
}) {}
